/*
 * Check required variables
 * */
function assertRequired(value: unknown, variableName: string) {
  if (value === undefined) {
    throw Error(`Env variable ${variableName} is required`)
  }
}

/* Версия приложения из package.json */
export const APP_VERSION = import.meta.env.APP_VERSION

/* API entrypoint */
export const API_URL = import.meta.env.VITE_API_URL
assertRequired(API_URL, 'VITE_API_URL')

/* End-to-end тестирование */
export const isE2eTest = import.meta.env.VITE_E2E_TEST === 'true'

/* Логирование */
export const LOG_LEVEL = import.meta.env.VITE_LOG_LEVEL || 'info'
export const isDebug = LOG_LEVEL === 'debug'

export const isTestStand = import.meta.env.STAND === 'TEST'
export const isDemoStand = import.meta.env.STAND === 'DEMO'
export const isProdStand = import.meta.env.STAND === 'PROD'

export const STAND_PREFIX = isProdStand ? '' : isDemoStand ? 'uat.' : 'test.'

export const CSS_DOMAIN = `https://css.${STAND_PREFIX}apark.pro/`
export const TMS_DOMAIN = `https://tms.${STAND_PREFIX}apark.pro/`
export const EPS_DOMAIN = `https://eps.${STAND_PREFIX}apark.pro/`
export const DDP_DOMAIN = `https://ddp.${STAND_PREFIX}apark.pro/`
export const TELEMATICS_DOMAIN = `https://telematics.${STAND_PREFIX}apark.pro/`
export const DRIVER_ADMIN_DOMAIN = `https://driver-admin.${STAND_PREFIX}apark.pro/`
export const NOTIFICATIONS_DOMAIN = `https://notifications.${STAND_PREFIX}apark.pro/`
